import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import { withRouter} from 'react-router-dom'
import userProfileQuery, {} from '../../../__generated__/UserProfileQuery.graphql'
import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'
import useSubscription from '../../../hooks/useSubscription'
import NotificationSubscription from '../../../subscriptions/NotificationSubscription'
import UserProfile from './UserProfile'



const UserProfileRoot = (props) => {
  const {
    match: {
      params: {teamId}
    }
  } = props
  useSubscription('UserProfileRoot', NotificationSubscription)
  const queryRef = useQueryLoaderNow(userProfileQuery, {})
  return (
    _jsx(Suspense, { fallback: '', children: 
      queryRef && _jsx(UserProfile, { queryRef: queryRef, teamId: teamId,} )
    })
  )
}

export default withRouter(UserProfileRoot)
